import React, { useState } from "react";
import { Button, DropdownItemProps, Header, Icon, Modal } from "semantic-ui-react";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import { viewerRoleConfigEnabledDBs } from "../../../../config/config";
import { Role } from "../../../../types/roles";
import { UserClaims } from "../../../../types/users";

type EditUserModalProps = {
  user: UserClaims | Record<string, never>;
  onEditUser: (roles: number[]) => void;
  roles: Role[];
  selectedRegionId: number;
  regionDB?: string;
  onClose: () => void;
};

const EditUserModal = (props: EditUserModalProps) => {
  const { user, onEditUser, roles, selectedRegionId, regionDB, onClose } = props;
  const userRoles = user.roles?.filter(role => role.regionId === selectedRegionId);
  const defaultValues = userRoles?.map(role => role.id) ?? [];
  const options = roles
    .filter(
      role =>
        viewerRoleConfigEnabledDBs.includes(regionDB ?? "") || role.code !== "URBANCANVAS_VIEWER"
    )
    .map(role => ({ key: role.id, text: role.name, value: role.id }));
  const [selected, setSelected] = useState(defaultValues);

  const handleChange = (event: any, { value }: any) => {
    setSelected([value]);
  };
  const changes =
    defaultValues.length !== selected.length ||
    defaultValues.some(defaultValue => !selected.includes(defaultValue));
  const renderLabel = (label: DropdownItemProps) => ({
    color: "blue",
    content: label.text,
    icon: "check"
  });
  const handleUserSaveRoles = () => {
    onEditUser(selected);
    onClose();
  };
  return (
    <Modal onClose={onClose} open={true} closeIcon>
      <Header icon="wrench" content={`Edit ${user.name} role`} />
      <Modal.Content>
        <Dropdown
          aria-label="User role selection"
          renderLabel={renderLabel}
          placeholder="Roles"
          onChange={handleChange}
          defaultValue={defaultValues[0]}
          fluid
          selection
          options={options}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          disabled={!changes || selected.length === 0}
          color="green"
          onClick={handleUserSaveRoles}
        >
          <Icon name="checkmark" /> Save changes
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EditUserModal;
